{
	"errorHaveEnoughSpace": "I Have Enough Space"
}
